import { useRouter } from 'vue-router'
import api from '@/api'
import { onMounted, toRef, reactive } from 'vue'

export default function useHomeLogic() {
    const router = useRouter()
    const data = reactive({
        linksOfStandardAndWednesday: [],
        linksOfOtherHot: [],
        linksOfAd: [],
        linksOfNormal: [],
    })

    const onRoute = (url) => {
        if (!url) {
            return
        }
        router.push(url)
    }

    const getLinksByGroupCode = async (code) => {
        const res = await api.getLinksByGroupCode(code)
        return res
    }

    const mapGroupToLinks = (group) => {
        return group.map(linkResp => {
            const { image, gotoUrl } = linkResp
            if (gotoUrl.indexOf(',') === -1) {
                return {
                    image,
                    loginedUrl: gotoUrl,
                    unLoginedUrl: gotoUrl,
                }
            }

            const [loginedUrl, unLoginedUrl] = gotoUrl.split(',')
            // const [unLoginedUrl, loginedUrl] = String.prototype.split.call(gotoUrl, ',')
            return {
                image,
                loginedUrl,
                unLoginedUrl,
            }
        })
    }

    onMounted(() => {
        getLinksByGroupCode('group1').then(res => {
            data.linksOfStandardAndWednesday = mapGroupToLinks(res.data.linkResps)
        })
        getLinksByGroupCode('group2').then(res => {
            data.linksOfOtherHot = mapGroupToLinks(res.data.linkResps)
        })
        getLinksByGroupCode('group3').then(res => {
            data.linksOfAd = mapGroupToLinks(res.data.linkResps)
        })
        getLinksByGroupCode('group4').then(res => {
            const links = mapGroupToLinks(res.data.linkResps)
            // 将links每三个分一组
            const linksOfNormal = []
            for (let i = 0; i < links.length; i += 3) {
                linksOfNormal.push(links.slice(i, i + 3))
            }

            data.linksOfNormal = linksOfNormal
        })
    })

    return {
        linksOfStandardAndWednesday: toRef(data, 'linksOfStandardAndWednesday'),
        linksOfOtherHot: toRef(data, 'linksOfOtherHot'),
        linksOfAd: toRef(data, 'linksOfAd'),
        linksOfNormal: toRef(data, 'linksOfNormal'),

        onRoute,
    }
}